export default {
  SET_SELECTED_DAY(state, day) {
    state.selectedDay = day;
  },
  SET_ACTIVED_WEEK_INDEX(state, index) {
    state.activedWeekIndex = index;
  },
  SET_AVAILABLE_TIMES(state, timesArray) {
    state.availableTimes = timesArray;
  },
};
